import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  ShoppingCart,
  FileText,
  FileMinus,
  Wallet,
  Ticket,
  Undo2,
  ShieldCheck,
  Settings,
  X,
} from 'lucide-react'

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/clienti', label: 'Clienți', icon: Users },
  { to: '/comenzi', label: 'Comenzi', icon: ShoppingCart },
  { to: '/facturi-vanzare', label: 'Facturi vânzare', icon: FileText },
  { to: '/facturi-cumparare', label: 'Facturi cumpărare', icon: FileMinus },
  { to: '/incasari', label: 'Generator EA', icon: Wallet },
  { to: '/retururi', label: 'Retururi', icon: Undo2 },
  { to: '/vouchere', label: 'Vouchere', icon: Ticket },
  { to: '/verificare', label: 'Verificare', icon: ShieldCheck },
  { to: '/setari', label: 'Setări', icon: Settings },
]

export function Sidebar({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <>
      {open && <div className="fixed inset-0 z-20 bg-black/30 md:hidden" onClick={onClose} />}
      <aside
        className={`fixed z-30 flex h-full w-60 flex-col border-r border-b4l-border bg-white transition-transform md:static md:translate-x-0 ${
          open ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex h-14 items-center justify-between border-b border-b4l-border px-4">
          <span className="text-[15px] font-semibold text-b4l-green-dark">eMAG Platform</span>
          <button className="md:hidden" onClick={onClose} aria-label="Închide meniul">
            <X size={18} />
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto p-2">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `mb-0.5 flex items-center gap-2.5 rounded-md px-3 py-2 text-[13px] transition-colors ${
                  isActive
                    ? 'bg-b4l-green-light font-medium text-b4l-green-dark'
                    : 'text-b4l-text-muted hover:bg-b4l-bg-soft'
                }`
              }
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-b4l-border p-3 text-[11px] text-b4l-text-dim">
          v0.1.0 — Faza 0
        </div>
      </aside>
    </>
  )
}
